import React from "react";
import { Link } from "react-router-dom";
import { reportList } from "../../core/json/master";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { ReportSidebarData } from "core/json/siderbar_data";
import { base_path } from "environment";

const ReportList = () => {
  return (
    <>
      {/* <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Report Module</h4>
              <h6>Genarate view and download reports</h6>
            </div>
          </div>
          <div className="card border-0">
            <div className="card-body grid-showcase grid-align">
              <div className="row justify-content-center">
                {reportList.map((data, index) => (
                  <>
                    <div className="col-3">
                      <Link to={data.link}>
                        <span className="bg-white text-dark">
                          {data.linkText}
                        </span>
                      </Link>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header mb-4">
            <div className="page-title">
              <h4 className="fw-bold">Report Module</h4>
              <h6 className="text-muted">
                Generate, view and download reports
              </h6>
            </div>
          </div>

          {/* Report Cards */}
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="row g-4">
                {reportList.map((data, index) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                    key={index}
                  >
                    <Link
                      to={data.link}
                      className="report-card text-decoration-none"
                    >
                      <div className="report-card-inner">
                        {/* Optional Icon */}
                        <div className="report-icon">
                          {/* <i className="ti ti-file-report"></i> */}
                          <ImageWithBasePath src={`${data.iconPath}${data.icon}`} />
                         
                        </div>

                        <div className="report-title">{data.linkText}</div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReportList;
